import { UserViewModel } from "../../viewmodels/setup/users/UserViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";
import MyAccountForm from "../../components/forms/my-account/MyAccountForm";
import MyPasswordForm from "../../components/forms/my-account/MyPasswordForm";
import EmptyModal from "../../components/modals/EmptyModal";

function MyAccount(props) {
  const { addSnackbar, email, logout, name, updateAccountDetails } = props;

  const {
    emptyModal,
    setEmptyModelOpen,

    updateAccountPassword,
  } = UserViewModel(addSnackbar, logout);

  return (
    <div className="min-h-screen bg-[#F6F8FB] px-4 py-5 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <section className="rounded-[18px] border border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
          <div className="border-b border-[#E2E8F0] px-6 py-5">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#64748B]">
              QA Trace / Account
            </p>
            <h1 className="mt-2 text-[1.65rem] font-semibold tracking-tight text-[#0F172A] sm:text-3xl">
              My Account
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-[#64748B]">
              Manage your profile details and password. Changes apply to your
              login credentials across the platform.
            </p>
          </div>
        </section>

        <div className="grid gap-6 lg:grid-cols-2 lg:items-start">
          <MyAccountForm
            updateAccountDetails={updateAccountDetails}
            userDetails={{
              name: name,
              email: email,
            }}
          />

          <MyPasswordForm updateAccountPassword={updateAccountPassword} />
        </div>

        <EmptyModal
          childComponent={emptyModal.childComponent}
          open={emptyModal.open}
          setOpen={setEmptyModelOpen}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    name: state.auth.name,
    email: state.auth.email,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    updateAccountDetails: (payload) =>
      dispatch(actions.updateAccountDetails(payload)),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyAccount),
);
